import {Card, styled} from '@mui/material';

export const StyledCard = styled(Card)`
	padding: 20px 16px;
	display: flex;
	flex-direction: column;
	gap: 12px;
	box-shadow: none;

	${({theme}) => theme.breakpoints.up('md')} {
		padding: 20px 32px;
	}
`;
